import { useEffect, useState } from 'react';
import { getSessionState, subscribeToSession } from './session';

export function useSession() {
  const [session, setSession] = useState(getSessionState());

  useEffect(() => {
    setSession(getSessionState());
    return subscribeToSession(setSession);
  }, []);

  return session;
}
